import { render, staticRenderFns } from "./alarmRoleSendConfig.vue?vue&type=template&id=511d8e94&scoped=true&"
import script from "./alarmRoleSendConfig.vue?vue&type=script&lang=js&"
export * from "./alarmRoleSendConfig.vue?vue&type=script&lang=js&"
import style0 from "./alarmRoleSendConfig.vue?vue&type=style&index=0&id=511d8e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511d8e94",
  null
  
)

export default component.exports